<template>
  <div class="div-img-404">
    <img src="./img/404.jpg" @click="returnHome" />
  </div>
</template>
<script>
  export default{
    methods: {
      returnHome(){
        location.href='/';
        //this.$router.push('/')
      }
    }
  }
</script>
<style>
  .div-img-404{
    background-color: #007bc1;
  }


@media only screen and (max-width: 768px) {
	.div-img-404 img{
		width: 100%;
	}
	 span {
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/404.vue